<template>
    <div class="increment-block">
        <!-- *********************************************
        *                      Label                     *
        ********************************************** -->
        <label-generic
        v-if="params.labelText"
        :text="params.labelText"
        :mandatory="params.mandatory"
        :errorState="params.errorState"/>
        <!-- *********************************************
        *                    Increment                   *
        ********************************************** -->
        <div class="value-controller-wrapper">
            <button-tertiary
            icon="minus"
            buttonSize="small"
            :disabled="params.minValue ? inputValue <= params.minValue : inputValue <= 1"
            @clicked="emit('valueChanged', inputValue - 1)"/>
            <!-- Value to be changed -->
            <div class="value">{{inputValue}}</div>
            <button-tertiary
            icon="plus"
            buttonSize="small"
            :disabled="inputValue >= params.maxValue"
            @clicked="emit('valueChanged', inputValue + 1)"/>
        </div>
    </div>
</template>

<script setup>
import LabelGeneric from '@/components/generic/labels/Generic'
import ButtonTertiary from '@/components/generic/buttons/Tertiary'
/* Vue */
import { watch } from 'vue'

/* Emmitters */
const emit = defineEmits(['valueChanged'])

/** props received
@params {
    - labelText {String}: label for textField
    - minValue {Number}
    - maxValue {Number}
    - mandatory {Boolean}
@inputValue {String, Number}: value to be displayed in input
*/
const props = defineProps({
    params: Object,
    inputValue: Number
})

/* Preventing our value from falling outside increment range */
const fixInputValue = () => {
    if (!props.inputValue) emit('valueChanged', props.params.minValue)
    else if (props.inputValue < props.params.minValue) emit('valueChanged', props.params.minValue)
    else if (props.inputValue > props.params.maxValue) emit('valueChanged', props.params.maxValue)
}

watch(() => props.inputValue, (newVal, oldVal) => {
    if (newVal !== oldVal) fixInputValue()
})

fixInputValue()
</script>

<style lang="scss" scoped>
.increment-block {
	width:100%;
	min-width: 250px;
    max-width: 400px;
	position: relative;

    .value-controller-wrapper {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 8px;

        .value {
            display: flex;
            align-items: center;
            justify-content: center;

            width: 40px;
            height: 40px;

            @include H5-Regular;

            color: var(--secondary-dark-1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }
}
</style>
